import React, { useState } from 'react';
import { Search, AlertCircle, Loader2 } from 'lucide-react';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';

const SearchPage = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showContactForm, setShowContactForm] = useState(false);

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      setError('Please enter a registration number');
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      await onSearch(searchQuery.trim().toUpperCase().replace(/\s/g, ''));
    } catch (err) {
      setError(err.message || 'An error occurred during search');
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleSearch();
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={() => setShowContactForm(true)} />
      
      {/* Blue service header */}
      <div className="bg-blue-600 text-white py-8">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="text-4xl font-bold">Check MOT history</h1>
          <p className="text-xl mt-2">Check the MOT status of a vehicle</p>
        </div>
      </div>

      <main className="max-w-5xl mx-auto px-4 py-8">
        <div className="bg-white">
          <div className="mb-8">
            <label htmlFor="registration" className="block text-lg font-bold mb-2">
              Enter registration number
            </label>
            <div className="flex gap-4">
              <input
                id="registration"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value.toUpperCase())}
                onKeyPress={handleKeyPress}
                placeholder="e.g. AB12 CDE"
                className="flex-1 max-w-xs px-3 py-2 text-lg border-2 border-black focus:outline-none focus:ring-4 focus:ring-yellow-400"
                disabled={loading}
              />
              <button
                onClick={handleSearch}
                disabled={loading}
                className="px-6 py-2 bg-green-600 text-white font-bold hover:bg-green-700 focus:outline-none focus:ring-4 focus:ring-yellow-400 disabled:opacity-50"
              >
                {loading ? (
                  <>
                    <Loader2 className="inline animate-spin h-5 w-5 mr-2" />
                    Checking...
                  </>
                ) : (
                  'Check MOT history'
                )}
              </button>
            </div>
            
            {error && (
              <div className="mt-4 p-4 border-l-4 border-red-600 bg-red-50">
                <p className="text-red-800 font-bold">There is a problem</p>
                <p className="text-red-800">{error}</p>
              </div>
            )}
          </div>

          <div className="border-t-2 border-gray-300 pt-6 mt-8">
            <h2 className="text-2xl font-bold mb-4">What this service provides</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>MOT test history</li>
              <li>Advisories and reasons for failure</li>
              <li>Vehicle details including colour, fuel type and registration date</li>
              <li>MOT expiry date</li>
              <li>Mileage history</li>
            </ul>
          </div>

          <div className="border-t-2 border-gray-300 pt-6 mt-8">
            <p className="text-sm text-gray-600">
              This is an independent service providing MOT history data. 
              We are not affiliated with the DVSA or any government agency.
            </p>
          </div>
        </div>
      </main>

      <ContactForm 
        isOpen={showContactForm} 
        onClose={() => setShowContactForm(false)} 
      />
    </div>
  );
};

export default SearchPage;
